import type { Client } from '../client';
import type { LoginRequest, LoginResponse, MeResponse } from '../types';

export function authEndpoints(client: Client) {
  return {
    login: (data: LoginRequest) =>
      client.post<LoginResponse>('/api/auth/login', data),

    logout: () => client.post<{ status: string }>('/api/auth/logout'),

    me: () => client.get<MeResponse>('/api/auth/me'),

    // ── TOTP two-factor (WS7) ─────────────────────────────────────
    totpStatus: () => client.get<{ enabled: boolean }>('/api/auth/totp/status'),

    totpSetup: () =>
      client.post<{ secret: string; otpauth_uri: string }>('/api/auth/totp/setup'),

    totpEnable: (code: string) =>
      client.post<{ status: string; enabled: boolean }>('/api/auth/totp/enable', { code }),

    totpDisable: (code: string) =>
      client.post<{ status: string; enabled: boolean }>('/api/auth/totp/disable', { code }),
  };
}
